export enum UserStatEntryType {
    client_widget_seen = 'client_widget_seen',
    client_widget_click = 'client_widget_click',
    client_widget_click_buy = 'client_widget_click_buy',
    client_widget_buy = 'client_widget_buy',
    client_widget_buy_first = 'client_widget_buy_first',
    client_payment_seen = 'client_payment_seen',
    client_payment_switch = 'client_payment_switch',
    client_payment_click_buy = 'client_payment_click_buy',
    client_action_seen_from_login = 'client_action_seen_from_login',
    client_action_buy_from_login = 'client_action_buy_from_login',
    client_action_seen_from_go_to_map = 'client_action_seen_from_go_to_map',
    client_action_buy_from_go_to_map = 'client_action_buy_from_go_to_map',
    client_action_seen_from_global_map = 'client_action_seen_from_global_map',
    client_action_buy_from_global_map = 'client_action_buy_from_global_map',
    client_bank_group_click = 'client_bank_group_click',
    client_interface_bank_link_seen = 'client_interface_bank_link_seen',
    client_interface_bank_link_click = 'client_interface_bank_link_click',
    client_interface_bank_link_close_bank_without_buy = 'client_interface_bank_link_close_bank_without_buy',
    client_interface_bank_link_buy = 'client_interface_bank_link_buy',
    client_march_with_reinforcement = 'client_march_with_reinforcement',
    client_unit_info_seen = 'client_unit_info_seen',
    client_send_private_chat_message = 'client_send_private_chat_message',
    client_click_chat_from_hero_info = 'client_click_chat_from_hero_info',
    client_click_chat_from_hero_avatar = 'client_click_chat_from_hero_avatar',
    client_clan_sent_message_to_journal_by_leads = 'client_clan_sent_message_to_journal_by_leads',
    client_seen_clan_lead_message_in_journal = 'client_seen_clan_lead_message_in_journal',
    client_subscription_widget_seen = 'client_subscription_widget_seen',
    client_subscription_widget_click = 'client_subscription_widget_click',
    client_subscription_window_close = 'client_subscription_window_close',
    client_subscription_click_subscribe = 'client_subscription_click_subscribe',
    client_subscription_change_pack = 'client_subscription_change_pack',
    client_fps_watcher = 'client_fps_watcher',
    client_memory_watcher = 'client_memory_watcher',
    client_memory_allocation_error = 'client_memory_allocation_error',
    client_enlarge_memory_arrays_error = 'client_enlarge_memory_arrays_error',
    client_memory_access_out_of_bounds_error = 'client_memory_access_out_of_bounds_error',
    client_out_of_memory_error = 'client_out_of_memory_error',
    client_create_unity_instance_error = 'client_create_unity_instance_error',
    client_user_change_preset = 'client_user_change_preset',
    client_external_click_google_play = 'client_external_click_google_play',
    client_rate_window_seen = 'client_rate_window_seen',
    client_rate_window_push_yes = 'client_rate_window_push_yes',
    client_rate_window_push_no = 'client_rate_window_push_no',
    client_choose_stars = 'client_choose_stars',
    client_choose_stars_close = 'client_choose_stars_close',
    client_choose_emoji = 'client_choose_emoji',
    client_choose_emoji_close = 'client_choose_emoji_close',
    client_window_with_store_link_seen = 'client_window_with_store_link_seen',
    client_window_with_store_link_push_go_store = 'client_window_with_store_link_push_go_store',
    client_window_with_store_link_push_close = 'client_window_with_store_link_push_close',
    client_social_like_showed = 'client_social_like_showed',
    client_social_like_closed = 'client_social_like_closed',
    client_social_like_clicked = 'client_social_like_clicked',
    client_steampay_error_window_seen = 'client_steampay_error_window_seen',
    client_steampay_error_window_close = 'client_steampay_error_window_close',
    client_steampay_error_window_click_go_to_site = 'client_steampay_error_window_click_go_to_site',
    client_sound_track_skipped = 'client_sound_track_skipped',
    client_sound_track_started = 'client_sound_track_started',
    client_monsters_list_try_map_fight = 'client_monsters_list_try_map_fight',
    client_monsters_list_map_fight = 'client_monsters_list_map_fight',
    client_preloader_progress = 'client_preloader_progress',
    client_compilation_stage_complete = 'client_compilation_stage_complete',
    client_start_bank_preloader = 'client_start_bank_preloader',
    client_end_bank_preloader = 'client_end_bank_preloader',
    client_sound_switch = 'client_sound_switch',
    client_screen_scroll = 'client_screen_scroll',
    client_first_click = 'client_first_click',
    client_100_clicks = 'client_100_clicks',
    client_load_progress = 'client_load_progress',
    client_load_map = 'client_load_map',
    client_load_city = 'client_load_city',
    client_load_global_map = 'client_load_global_map',
    client_web_fake_preloader_percents = 'client_web_fake_preloader_percents',
    client_first_click_experiment = 'client_first_click_experiment',
    client_community_link_click = 'client_community_link_click',
    client_fcm_notification_access = 'client_fcm_notification_access',
    client_preloader_video_closed = 'client_preloader_video_closed',
    client_preloader_video_initiating = 'client_preloader_video_initiating',
    client_preloader_video_unmuted = 'client_preloader_video_unmuted',
    client_new_loader_pre_init_started = 'client_new_loader_pre_init_started',
    client_new_loader_pre_run_started = 'client_new_loader_pre_run_started',
    client_new_loader_post_run_started = 'client_new_loader_post_run_started',
    client_new_loader_runtime_initialized = 'client_new_loader_runtime_initialized',
    client_payment_method_chosen = 'client_payment_method_chosen',
    client_payment_proceed = 'client_payment_proceed',
    marketing_click_referral_link = 'client_marketing_click_referral_link',
    client_connection_check_start = 'client_connection_check_start',
    client_connection_check_http = 'client_connection_check_http',
    client_connection_check_ws = 'client_connection_check_ws',
}
